import { ChantContext } from '../../gregorio-chant/ChantContext';
import { Length } from './Length';
import { RubberLength } from './RubberLength';

export class DistanceConverter {
  private _context: ChantContext;

  constructor(context: ChantContext) {
    this._context = context;
  }

  lengthToPx(len: Length | RubberLength): number {
    if (len instanceof RubberLength) {
      return this.lengthToPx(len.space);
    }

    switch (len.unit) {
      case 'cm':
        return len.space * this._context.pxInCm;
      case 'mm':
        return len.space * this._context.pxInCm / 10;
      case 'ex':
        return len.space * this._context.pxInEx;
      case 'pt':
        return len.space * this._context.pxInPt;
    }
  }

  lengthToPxString(len: Length): string {
    return String(this.lengthToPx(len));
  }
}
